import * as React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CreateCaseDialog from "../../../components/dialogs/createCase";

interface Props {}
interface State {}
export default class AddCaseButton extends React.Component<Props, State> {
  state = {
    showNewCase: false
  };
  render() {
    return (
      <React.Fragment>
        <CreateCaseDialog
          open={this.state.showNewCase}
          onCreate={caseID => {
            // this.props.fetchCases();
            window.location.href = "/case/" + caseID;
          }}
          onClose={() => this.setState({ showNewCase: false })}
        />
        <Button
          onClick={() => this.setState({ showNewCase: true })}
          variant="fab"
          color="primary"
          aria-label="Add"
          style={{
            position: "absolute",
            bottom: 32,
            right: 32
          }}
        >
          <AddIcon />
        </Button>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/cases/components/addCaseButton.tsx